import './components/questionsAndAnswers';
import './components/more';
import './components/js-form-validator';
import TetherSelect from 'tether-select';

import Stepper from './components/stepper';
import validatorOptions from './components/validatorOptions';

(function () {
  const steps = document.querySelectorAll('.stepper__step');
  const stepsWrapper = document.querySelector('.stepper');
  const nextStepButton = document.querySelector('.stepper__next');
  const prevStepButton = document.querySelector('.stepper__previous');
  const submitButton = document.querySelector('.stepper__submit');
  const progressBar = document.querySelector('.stepper__progressBar');

  const validator = [];
  for (let i = 0; i < steps.length; i++) {
    const fieldset = document.getElementById('formStep' + (i + 1));
    if (fieldset) {
      validator[i] = new Validator(
        fieldset,
        function (err, res) {
	   console.log(err, res);
          return res;
        },
        validatorOptions
      );
      let k = i;
      for (const element of fieldset.elements) {
        element.addEventListener('change', function () {
          setTimeout(function () {
            if (validator[k].validate()) {
              nextStepButton.disabled = false;
              submitButton.disabled = false;
            } else {
              nextStepButton.disabled = true;
              submitButton.disabled = true;
              validator[k].showErrors();
            }
          }, 50);
        });

        element.addEventListener('keydown', function () {
          setTimeout(function () {
            if (validator[k].validate()) {
              nextStepButton.disabled = false;
              submitButton.disabled = false;
            }
          }, 50);
        });
      }
    }
  }

  const stepper = new Stepper(
    steps,
    stepsWrapper,
    nextStepButton,
    prevStepButton,
    submitButton,
    progressBar,
    validator
  );

  const selectFields = document.querySelectorAll('select');

  for (const select of selectFields) {
    new TetherSelect({
      el: select,
      className: 'select-theme-swm',
    });
  }
})();
